module.exports = __webpack_public_path__ + "img/table_chart.c8d4452c.svg";